import gql from 'graphql-tag'

export default gql`query projectInvoice($project_id: String!){
  projectInvoice: project(project_id: $project_id){
    project_id
    
    name
    project_status_id
    project_status{
        description
    }
    project_clients{
      client{
        client_id
        name
        invoice_prefix
      }
    }
    project_client_budgets{
      project_activity_budget_id
      client_id
      project_id
      project_activity_type_id
      project_activity_type{
        description
      }
      description
      stage
      amount_to_invoice
      budget_label
    }
    total_budget
    total_fees
    total_invoiced
    total_writeoff
    amount_to_invoice
  }

}`